import {Link as ReactRouterLink} from "react-router-dom";
import {Link as StencilLink} from "@amzn/stencil-react-components/link";

export const RouterLink = StencilLink.withComponent(ReactRouterLink)

RouterLink.defaultProps = {
  ...StencilLink.defaultProps
}

export const NavigationTo = {
  AtGlance: "/dashboard",
  StockAwards: "/stock-awards",
  AvailableBrokers: "/broker",
  StockFAQs: "/more-about-stock",

  Impersonate: "/impersonate",
  Maintenance: "/maintenance",
}

export const NAVIGATION_TAB_GROUP = "navigation-tab-bar"